export default __webpack_public_path__ + "static/media/avatar.b9d66bd0.png";